import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuoteLeft, faBullseye, faUserTie, faCheckCircle, faEye, faGraduationCap, faClock, faMedal, faHospital, faUserNurse, faGlobe } from '@fortawesome/free-solid-svg-icons';
import programStudi from '../data/programStudi';
import kaprodiNarasi from '../data/kaprodiNarasi';
import '../styles/ProgramStudiPage.css';

// Map icon type to FontAwesome icon
const iconMap = {
  hospital: faHospital,
  userNurse: faUserNurse,
  globe: faGlobe
};

const ProgramStudi = () => {
  // Gabungkan data program studi dengan narasi kaprodi
  const prodiData = programStudi.map(prodi => {
    const narasi = kaprodiNarasi.find(n => n.kodeProdi === prodi.kode);
    return { ...prodi, ...narasi };
  });

  return (
    <main className="program-studi-page">
      {/* Hero Section */}
      <section className="prodi-hero">
        <div className="prodi-hero-overlay"></div>
        <div className="container">
          <h1>Program Studi</h1>
          <p>Temukan program studi yang tepat untuk membangun karir Anda di bidang kesehatan</p>
        </div>
      </section>

      {/* Program Studi Cards Overview */}
      <section className="prodi-overview section">
        <div className="container">
          <div className="prodi-overview-grid">
            {programStudi.map((prodi) => (
              <div key={prodi.id} className="prodi-overview-card">
                <div className="prodi-overview-icon">
                  <FontAwesomeIcon icon={iconMap[prodi.iconType]} />
                </div>
                <h3>{prodi.nama}</h3>
                <div className="prodi-overview-badges">
                  <span className="badge badge-jenjang">{prodi.jenjang}</span>
                </div>
                <div className="prodi-overview-info">
                  <div><FontAwesomeIcon icon={faClock} /> {prodi.durasi}</div>
                  <div><FontAwesomeIcon icon={faGraduationCap} /> {prodi.gelar}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Narasi Kaprodi Section */}
      <section className="kaprodi-narasi-section section">
        <div className="container">
          <div className="section-title">
            <h2>Pesan dari Ketua Program Studi</h2>
            <p>Visi, misi, dan tujuan program studi yang disampaikan langsung oleh para pemimpin akademik kami</p>
          </div>

          <div className="narasi-list">
            {prodiData.map((prodi, index) => (
              <div key={prodi.id} className={`narasi-block ${index % 2 === 1 ? 'reverse' : ''}`}>
                {/* Kaprodi Card */}
                <div className="kaprodi-card">
                  <div className="kaprodi-prodi-badge">
                    <FontAwesomeIcon icon={iconMap[prodi.iconType]} className="prodi-icon-small" />
                    <span>{prodi.nama}</span>
                  </div>
                  <div className="kaprodi-avatar">
                    <FontAwesomeIcon icon={faUserTie} />
                  </div>
                  <h3>{prodi.kaprodi?.nama}</h3>
                  <span className="kaprodi-title">Ketua Program Studi</span>
                  
                  <div className="kaprodi-quote">
                    <FontAwesomeIcon icon={faQuoteLeft} className="quote-icon" />
                    <p>"{prodi.quote}"</p>
                  </div>
                </div>

                {/* Tujuan & Kompetensi Card */}
                <div className="narasi-content">
                  {/* Visi Prodi */}
                  <div className="visi-prodi-card">
                    <div className="visi-header">
                      <FontAwesomeIcon icon={faEye} />
                      <h4>Visi Program Studi</h4>
                    </div>
                    <p>{prodi.visiProdi}</p>
                  </div>

                  {/* Tujuan */}
                  <div className="tujuan-card">
                    <div className="tujuan-header">
                      <FontAwesomeIcon icon={faBullseye} />
                      <h4>Tujuan Program Studi</h4>
                    </div>
                    <ul className="tujuan-list">
                      {prodi.tujuan?.map((item, idx) => (
                        <li key={idx}>
                          <span className="tujuan-number">{idx + 1}</span>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Kompetensi Lulusan */}
                  <div className="kompetensi-card">
                    <div className="kompetensi-header">
                      <FontAwesomeIcon icon={faMedal} />
                      <h4>Kompetensi Lulusan</h4>
                    </div>
                    <div className="kompetensi-list">
                      {prodi.kompetensiLulusan?.map((item, idx) => (
                        <div key={idx} className="kompetensi-item">
                          <FontAwesomeIcon icon={faCheckCircle} />
                          <span>{item}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="prodi-cta section">
        <div className="container">
          <div className="prodi-cta-content">
            <h2>Siap Bergabung dengan Kami?</h2>
            <p>Daftarkan diri Anda sekarang dan mulai perjalanan menuju karir profesional di bidang kesehatan</p>
            <div className="prodi-cta-buttons">
              <a href="/pendaftaran" className="btn btn-primary">Daftar Sekarang</a>
              <a href="/kontak" className="btn btn-outline">Hubungi Kami</a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ProgramStudi;
